const left = document.querySelector('.left');
const right = document.querySelector('.right');

function changeColor(event) {
	if (event.type === 'mouseenter') {
		if (event.target === right) {
			left.classList.add('active');
		} else if (event.target === left) {
			right.classList.add('active');
		}
	} else if (event.type === 'mouseleave') {
		if (event.target === right) {
			left.classList.remove('active');
		} else if (event.target === left) {
			right.classList.remove('active');
		}
	}
}

import lottie from 'lottie-web';
import { create } from '@lottiefiles/lottie-interactivity';

function initializeLottie() {
	const player = document.getElementById('PSLottie');

	if (!player) {
		return;
	}
	console.log('test');

	if (!player) {
		console.log('Player not found');
		// return;
	} else {
		console.log('Player found');
	}

	const path = player.getAttribute('data-animation-path');

	// Function to load Lottie animation
	let lottieInstance = lottie.loadAnimation({
		container: player,
		loop: false,
		autoplay: true,
		speed: 1,
		path: path,
		renderer: 'svg',
		rendererSettings: {
			background: 'transparent',
		},
	});

	lottieInstance.addEventListener('load', () => {
		console.error('player load');
	});

	lottieInstance.addEventListener('error', () => {
		console.error('player error');
	});

	console.log('Animation pre-ready');
	lottieInstance.addEventListener('ready', () => {
		console.log('Animation ready');
	});

	console.log('Animation pre complete');
	lottieInstance.addEventListener('complete', () => {
		console.log('Animation complete');
		var body = document.body;
		body.classList.add('loaded');
	});
}

// document.addEventListener('DOMContentLoaded', initializeLottie);
initializeLottie();

// var body = document.body;
// body.classList.add('loaded');
